import React from 'react';

const Context = React.createContext({
  baseURL: null,
  coreCdnHost: null,
  mobileApp: null,
  features: null,
  hydrated: false
});

Context.displayName = 'Context';
export default Context;
